// AUTOGENERATED — do not edit. Source: schemas/modes/sound_analysis_midi.json. Run `bun run codegen/generate.ts` to regenerate.
import type { ModeSchema } from './types';

export interface SoundAnalysisMidiParams {
  readonly midi_cc0: number;
  readonly midi_cc1: number;
  readonly midi_cc2: number;
  readonly midi_cc3: number;
  readonly midi_cc4: number;
  readonly midi_cc5: number;
  readonly midi_cc6: number;
  readonly midi_cc7: number;
}

export const SoundAnalysisMidiSchema: ModeSchema = {
  mode_id: 'sound_analysis_midi',
  engine_id: 'thru',
  ml: {
    input_channels: [
      'audio_pitch',
      'audio_aperiodicity',
      'audio_energy',
      'audio_attack',
      'audio_brightness',
      'audio_energy_crude',
      'joy_x',
      'joy_y',
      'joy_z',
      'joy_w',
    ],
    input_size: 10,
    hidden_layers: [
      10,
      10,
      14,
    ],
    output_size: 8,
    default_spread: 0.6,
  },
  params: [
    {
      name: 'midi_cc0',
      label: 'MIDI CC 0',
      min: 0,
      max: 1,
      default: 0.5,
      curve: 'linear',
      group: 'midi',
    },
    {
      name: 'midi_cc1',
      label: 'MIDI CC 1',
      min: 0,
      max: 1,
      default: 0.5,
      curve: 'linear',
      group: 'midi',
    },
    {
      name: 'midi_cc2',
      label: 'MIDI CC 2',
      min: 0,
      max: 1,
      default: 0.5,
      curve: 'linear',
      group: 'midi',
    },
    {
      name: 'midi_cc3',
      label: 'MIDI CC 3',
      min: 0,
      max: 1,
      default: 0.5,
      curve: 'linear',
      group: 'midi',
    },
    {
      name: 'midi_cc4',
      label: 'MIDI CC 4',
      min: 0,
      max: 1,
      default: 0.5,
      curve: 'linear',
      group: 'midi',
    },
    {
      name: 'midi_cc5',
      label: 'MIDI CC 5',
      min: 0,
      max: 1,
      default: 0.5,
      curve: 'linear',
      group: 'midi',
    },
    {
      name: 'midi_cc6',
      label: 'MIDI CC 6',
      min: 0,
      max: 1,
      default: 0.5,
      curve: 'linear',
      group: 'midi',
    },
    {
      name: 'midi_cc7',
      label: 'MIDI CC 7',
      min: 0,
      max: 1,
      default: 0.5,
      curve: 'linear',
      group: 'midi',
    },
  ],
  voice_spaces: [],
  curve_overrides: [],
  ui: {
    primary_input: 'audio_in',
    show_voice_space_selector: false,
    show_synth_visualizer: false,
  },
};
